// Used in teacher-classes.component.html and content-library-container.component.html

// Angular
import { OnInit, Component, ChangeDetectionStrategy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
    selector: "no-active-teacher-classes",
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: [
        "no-active-teacher-classes.component.scss",
        "../../../../teacher/teacher.component.scss",
        "../../../styles/shared-styles.scss",
    ],
    template: `
        <section
          class="no-classes"
          fxLayout="column"
          fxLayoutAlign="center center"
          >
          <div><img [src]="coursesIcon" /></div>
          <div class="card-content">
            <h3 class="no-classes-heading">You have no classes!</h3>
            <p class="no-classes-p">
              Select <span class="bold">"Add New Class"</span> to get
              started!
            </p>
            <!-- Add Course Button -->
            @if (contentLib) {
              <button
                type="button"
                aria-label="Add New Class"
                class="standard-button button-big button-background-teal"
                (click)="goToCourseForm()"
                >
                Add New Class
              </button>
            }
          </div>
        </section>
        `,
    standalone: false
})
export class NoActiveTeacherClassesComponent implements OnInit {
    coursesIcon = "./assets/images/teacher/rocketIcon.png";
    public contentLib = false;

    constructor(private router: Router, private route: ActivatedRoute) {}

    ngOnInit() {
        if (this.router.routerState.snapshot.url.includes("assign")) {
            this.contentLib = true; // Content Library, assign page. We want the button
        } else {
            this.contentLib = false; // Courses, landing page. We don't want the button
        }
    }

    goToCourseForm() {
        if (this.router.routerState.snapshot.url.includes("distributor")) {
            this.router.navigate([`new`], {
                relativeTo: this.route,
            });
        } else {
            this.router.navigate([`/teacher/classes/new`]);
        }
    }
}
